import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface PWBridgeComm {
    bridgeYourTeamExpandedChange: () => Observable<boolean>;
}

@Injectable({ providedIn: 'root' })
export class PWBridge {
    private _pwBridgeComm: PWBridgeComm;

    connect(value: PWBridgeComm): void {
        this._pwBridgeComm = value;
    }

    disconnect(): void {
        this._pwBridgeComm = null;
    }

    bridgeYourTeamExpandedChange(): Observable<boolean> {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        if (
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            this._pwBridgeComm &&
            this._pwBridgeComm.bridgeYourTeamExpandedChange
        ) {
            return this._pwBridgeComm.bridgeYourTeamExpandedChange();
        }
        return undefined;
    }
}
